export default __webpack_public_path__ + "f73ac5c15481be4cca19072e9ceb3676.png";